import { Component, OnInit, TemplateRef } from '@angular/core';
import {
  BusinessEntityListItem,
  BusinessEntityListResult,
  GetUserBusinessEntitiesOpts
} from '../../interfaces/business-entity';
import { BusinessEntity } from '../../models/business-entity';
import { AvailableFileListColumns } from '../../models/file';
import { BusinessEntityControllerService } from '../../services/business-entity-controller.service';
import { FileControllerService } from '../../services/file-controller.service';
import { environment } from '../../../environments/environment';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { plainToInstance } from 'class-transformer';
import { GlobalStateProviderService } from '../../services/global-state-provider.service';

interface orderings {
  name: { isReverse: boolean; value: string };
  created_at: { isReverse: boolean; value: string };
  updated_at: { isReverse: boolean; value: string };
}

@Component({
  selector: 'app-business-list',
  templateUrl: './business-list.component.html'
})
export class BusinessListComponent implements OnInit {
  DATETIME_FORMAT: string = environment.DATETIME_FORMAT;
  AvailableFileListColumns = AvailableFileListColumns;
  beList: BusinessEntityListItem[] = [];
  bsModalRef?: BsModalRef;
  currentBePage = 1;
  currentlyEdited: BusinessEntityListItem | null = null;
  beTotal = 0;
  orderings: orderings = {
    name: { isReverse: false, value: 'name' },
    created_at: { isReverse: false, value: 'created_at' },
    updated_at: { isReverse: false, value: 'updated_at' }
  };
  ordering = this.orderings.name;

  constructor(
    private readonly businessEntityController: BusinessEntityControllerService,
    private readonly fileController: FileControllerService,
    public modalService: BsModalService,
    public globalStateProviderService: GlobalStateProviderService
  ) {}

  ngOnInit(): void {
    this.getBusinessEntities({ skip_files: true });
  }

  confirmNameChangeModal(template: TemplateRef<any>) {
    const initialState: ModalOptions = {
      class: 'danger confirmation-modal modal-dialog-centered'
    };
    this.bsModalRef = this.modalService.show(template, initialState);
  }

  getBusinessEntities(opt?: GetUserBusinessEntitiesOpts) {
    const opts: GetUserBusinessEntitiesOpts = opt ? { ...opt } : {};
    opts.order_by = this.ordering.isReverse
      ? `-${this.ordering.value}`
      : this.ordering.value;
    opts.page = this.currentBePage;

    this.businessEntityController
      .getBusinessEntities(opts)
      .subscribe((result: BusinessEntityListResult) => {
        this.beList = result.results.map((beli: any) => {
          beli = plainToInstance(BusinessEntityListItem, beli);
          this.fileController
            .getUserFiles({
              page: beli.currentFilesPage,
              businessEntity: beli.business_entity_id
            })
            .subscribe((result) => {
              beli.toFileSet(result.results);
            });
          return beli;
        });
        this.beTotal = result.count;
      });
  }

  orderBy(key: keyof orderings) {
    // eslint-disable-next-line security/detect-object-injection -- TypeScript keyof ensures type-safe access
    this.ordering = this.orderings[key];
    this.ordering.isReverse = !this.ordering.isReverse;
    this.getBusinessEntities();
  }

  onPageChange(page: number) {
    this.currentBePage = page;
    this.getBusinessEntities();
  }

  startNameChange(be: BusinessEntityListItem) {
    be.nameEdition = true;
    this.beList.forEach((beItem) => {
      if (beItem.business_entity_id !== be.business_entity_id) {
        beItem.nameEdition = false;
      }
    });
    this.currentlyEdited = be;
  }

  confirmNameChange() {
    this.businessEntityController
      .updateBusinessEntity(this.currentlyEdited as BusinessEntity)
      .subscribe({
        next: () => {
          if (this.currentlyEdited) {
            this.currentlyEdited.originalName = this.currentlyEdited.name;
            this.currentlyEdited.nameEdition = false;
            this.currentlyEdited = null;
          }
        },
        error: () => {
          // generic error handling for ajax calls...
        }
      });
  }
}
